module.exports = __webpack_public_path__ + "img/23.c6dac5b2.png";